import { createSlice } from '@reduxjs/toolkit';

import { receivedIndiaBoxes, getIndiaQCInspection, indiaUploadRemarks, indiaGetRemarks, verifyIndiaQcInspection, createIndiaPO, updateAttributes, getAttributes, getReconciliatedOrders, updateReconciliatedOrders } from '../../apis';

export const IndiaQCPlatform = createSlice({

    name: 'indiaQcPlatform',
    initialState: {
        loading: false,
        error: '',
        receivedIndiaBoxesData: [],
        indiaQCInspectionData: [],
        indiaUploadRemarksSuccess: false,
        indiaGetRemarksData: [],
        verifyIndiaQcInspectionSuccess: false,
        createIndiaPOSuccess: false,
        updateAttributesSuccess: false,
        getAttributesData : {},
        getReconciliatedOrdersData : {},
        updateReconciliatedOrdersSuccess: false
    },
    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clearIndiaUploadRemarksSuccess: (state, action) => {
            return {
                ...state,
                indiaUploadRemarksSuccess: action.payload
            }
        },
        clearIndiaGetRemarksData: (state, action) => {
            return {
                ...state,
                indiaGetRemarksData: action.payload
            }
        },
        clearVerifyIndiaQcInspectionSuccess: (state, action) => {
            return {
                ...state,
                verifyIndiaQcInspectionSuccess: action.payload
            }
        },
        clearCreateIndiaPOSuccess: (state, action) => {
            return {
                ...state,
                createIndiaPOSuccess: action.payload
            }
        },
        clearUpdateAttributesSuccess: (state, action) => {
            return {
                ...state,
                updateAttributesSuccess: action.payload
            }
        },
        clearUpdateReconciliatedOrdersSuccess: (state, action) => {
            return {
                ...state,
                updateReconciliatedOrdersSuccess: action.payload
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(receivedIndiaBoxes.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(receivedIndiaBoxes.fulfilled, (state, action) => {
            state.loading = false;
            state.receivedIndiaBoxesData = action.payload.data
        })
        builder.addCase(receivedIndiaBoxes.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(getIndiaQCInspection.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getIndiaQCInspection.fulfilled, (state, action) => {
            state.loading = false;
            state.indiaQCInspectionData = action.payload.data
        })
        builder.addCase(getIndiaQCInspection.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(indiaUploadRemarks.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(indiaUploadRemarks.fulfilled, (state, action) => {
            state.loading = false;
            state.indiaUploadRemarksSuccess = true
        })
        builder.addCase(indiaUploadRemarks.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(indiaGetRemarks.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(indiaGetRemarks.fulfilled, (state, action) => {
            state.loading = false;
            state.indiaGetRemarksData = action.payload.data
        })
        builder.addCase(indiaGetRemarks.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(verifyIndiaQcInspection.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(verifyIndiaQcInspection.fulfilled, (state, action) => {
            state.loading = false;
            state.verifyIndiaQcInspectionSuccess = true
        })
        builder.addCase(verifyIndiaQcInspection.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(createIndiaPO.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(createIndiaPO.fulfilled, (state, action) => {
            state.loading = false;
            state.createIndiaPOSuccess = true
        })
        builder.addCase(createIndiaPO.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(updateAttributes.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(updateAttributes.fulfilled, (state, action) => {
            state.loading = false;
            state.updateAttributesSuccess = true
            state.error = false
        })
        builder.addCase(updateAttributes.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(getAttributes.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getAttributes.fulfilled, (state, action) => {
            state.loading = false;
            state.getAttributesData = action.payload.data
            state.error = false
        })
        builder.addCase(getAttributes.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(getReconciliatedOrders.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getReconciliatedOrders.fulfilled, (state, action) => {
            state.loading = false;
            state.getReconciliatedOrdersData = action.payload.data
        })
        builder.addCase(getReconciliatedOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(updateReconciliatedOrders.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(updateReconciliatedOrders.fulfilled, (state, action) => {
            state.loading = false;
            state.updateReconciliatedOrdersSuccess = true
            state.error = false
        })
        builder.addCase(updateReconciliatedOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
    }
})

export const { clearError, clearIndiaUploadRemarksSuccess, clearIndiaGetRemarksData, clearVerifyIndiaQcInspectionSuccess, clearCreateIndiaPOSuccess, clearUpdateAttributesSuccess, clearUpdateReconciliatedOrdersSuccess } = IndiaQCPlatform.actions

export default IndiaQCPlatform.reducer